import React, { useState, useEffect} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
import FileUpload from "../../components/FileUpload";



const PhonebookuploadCreate = ()=>{
     const [phonebook, setPhonebook ] =  useState([]);
     const [phonebookId, setPhonebookId] = useState(0);
     const [uploadfile, setUploadfile ] = useState('');
     const [page, setPage] = useState(1);
    
    //  const [timein, setTimein ] = useState('');
     const [redirect, setRedirect] = useState(false);
     useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`phonebook?page=${page}`);
            setPhonebook(data.data); 
        }
        )();
    },[page]);
    


     const submit = async (e)=>{
         e.preventDefault();
        // console.log(phonebookId);
         const {data} = await axios.post('phonebookUpload', {
            phonebook_id: parseInt(phonebookId),
            upload_file:uploadfile,
        });
       // console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/phonebookupload'} />
    }
     return (
         <Wrapper pageTitle={"New Phonebookupload"}>
            <InnerNav createLink={'/phonebookuploadCreate'} listLink={'/phonebookupload'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Phonebook </span>
                        <select
                            className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                            placeholder="Phonebook"
                            onChange = {e => setPhonebookId(e.target.value)} >
                                <option key='0' value='0' >Choose Phonebook</option>

                            {phonebook.map((phonebook)=>{
                                         return(
                                             <option key={phonebook.id} value={phonebook.id} >
                                                {phonebook.name}
                                             </option>
                                         );
                                     })
                                 }

                            </select>
                    </label>

                    {/* <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Uploadfile </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Uploadfile"
                        onChange = {e => setUploadfile(e.target.value)} />
                    </label> */}

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Uploadfile </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Uploadfile"
                        value={uploadfile}
                        onChange = {e => setUploadfile(e.target.value)} />
                        
                        <FileUpload uploaded={setUploadfile} />
                    
                    </label>

                    {/* <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Timein </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Timein"
                        onChange = {e => setTimein(e.target.value)} />
                    </label> */}

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default PhonebookuploadCreate;